import { render, staticRenderFns } from "./AddUserForm.vue?vue&type=template&id=6512acd8&"
import script from "./AddUserForm.vue?vue&type=script&lang=js&"
export * from "./AddUserForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports